// extracted by mini-css-extract-plugin
export default {"forecast__dailylist":"ForecastDailyList_forecast__dailylist__VD0LI"};